export const gutter = 16
export const topMarginStyle = ({ theme }) => ({ marginTop: theme['default-spacer-md'] })
